// extracted by mini-css-extract-plugin
export var skipAnimation = "_1j-0";